<script setup>
import { useCasinoGamesStore } from "~/stores/casino-games";

const casinoGamesStore = useCasinoGamesStore();

const props = defineProps({
  games: {
    type: Array,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div>
    <div
      class="grid grid-cols-2 gap-4 xs:grid-cols-3 sm:grid-cols-4 md:grid-cols-5 md:gap-5 xl:grid-cols-6"
    >
      <BaseGame v-for="game in games" :data="game" :key="game.id"/>
      <BaseGame :shimmer="isLoading" v-if="isLoading" v-for="i in 36" :key="i"/>
      <PageLoadersCassinoLoader v-if="isLoading" />
    </div>
    <div
      v-if="casinoGamesStore.games.length === 0"
      class="mt-5 flex items-center justify-center rounded-sm bg-black/30 p-6 text-center"
    >
      <div
        v-if="
          casinoGamesStore.state.searchString !== '' ||
          casinoGamesStore.state.searchByProvider.length > 0
        "
      >
        <p>Não há nenhum jogo disponível com os filtros selecionados.</p>
        <p
          class="cursor-pointer text-sm opacity-50 hover:opacity-100"
          @click="
            casinoGamesStore.resetFilters();
            casinoGamesStore.get();
          "
        >
          Que tal visualizar todos os jogos?
        </p>
      </div>
      <div v-else>Não há nenhum jogo disponível.</div>
    </div>
  </div>
</template>
